import { render, staticRenderFns } from "./TabTimer.vue?vue&type=template&id=cee021a8&"
import script from "./TabTimer.vue?vue&type=script&lang=js&"
export * from "./TabTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab})
